export const StandardServicesMix = {
  data() {
    return {
      standardServices: [
        {
          name: 'HDMI Cable',
          description: '高清数据线',
          iconName: '高清数据线.png',
        },
        {
          name: 'Monitor',
          description: '监视器',
          iconName: '监视器.png',
        },
        {
          name: 'Whiteboard/Writable wall',
          description: '白板/可书写墙',
          iconName: '白板.png',
        },
        {
          name: 'Window',
          description: '窗户',
          iconName: '窗户.png',
        },
        {
          name: 'Projector',
          description: '投影仪',
          iconName: '投影仪.png',
        },
        {
          name: 'Phone',
          description: '电话',
          iconName: '电话.png',
        },
        {
          name: 'Round Table',
          description: '圆桌会议',
          iconName: '圆桌会议.png',
        },

        {
          name: 'Smart Table',
          description: '互动桌',
          iconName: '互动桌.png',
        },
        {
          name: 'Speaker Phone',
          description: '扬声器电话',
          iconName: '扬声器电话.png',
        },
        {
          name: 'VC - Surface Hub',
          description: 'VC-表面轮毂',
          iconName: 'VC-表面轮毂.png',
        },
        {
          name: 'Wireless Content Sharing',
          description: '无线内容共享',
          iconName: '无线内容分享.png',
        },
        {
          name: 'VC - Cyviz',
          description: 'VC - Cyviz',
          iconName: 'Cyviz.png',
        },
        {
          name: 'VC System',
          description: 'VC系统',
          iconName: 'VC系统.png',
        },
        {
          name: 'Adjoining Room/Collapsible Wall',
          description: '相邻房间/可折叠墙',
          iconName: '相邻房间-可折叠墙.png',
        },
        {
          name: 'VC - Microsoft Teams Room',
          description: 'VC-微软团队室',
          iconName: 'VC-微软团队室.png',
        },
      ],
    }
  },
  methods: {
    getStandardServiceByName(code) {
      return this.standardServices.find(item => item.name === code)
    },
    splitStandardServices(standardServices) {
      return standardServices.split(',')
    },
  },
}
